import styled from 'styled-components';

export const SectionTitle = styled.h2`
  display: block;
  text-align: center;
  margin-bottom: 20px;
  margin-top: 0px;
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.31;
  letter-spacing: 1.5px;
  text-align: center;
  color: #494f5a;
  text-transform: uppercase;
`;

export const SectionTitleWithTopMargin = styled(SectionTitle)`
  margin-top: ${props => props.marginTop}px;
`;

export default SectionTitle;
